import changelogData from "../../../../../pages/inventory/docs/changelog-inventory.json5";
import * as React from 'react';
export default {
  changelogData,
  React
};